import React from "react";
import BasketballFullCourt from "./BasketballFullCourt.tsx";
import BasketballHalfCourt from "./BasketballHalfCourt.tsx";
import { UISETTINGSINIT } from "./BoardConstants.ts";

type CourtColors = {
  lineColor?: string;
  paintAreaColor?: string | null;
  paintAreaUseWoodPattern?: boolean;
  midRangeColor?: string | null;
  midRangeUseWoodPattern?: boolean;
  outOfBoundsColor?: string | null;
  outOfBoundsUseWoodPattern?: boolean;
  hideLogo?: boolean;
  hideBorders?: boolean;
};

interface CourtProps extends CourtColors {
  courtType: "halfcourt" | "fullcourt";
}

export default function Court({ courtType, ...colors }: CourtProps) {
  const defaults = UISETTINGSINIT;
  const resolved = {
    lineColor: colors.lineColor ?? defaults.courtLineColor,
    paintAreaColor: colors.paintAreaColor ?? defaults.courtPaintAreaColor,
    paintAreaUseWoodPattern:
      colors.paintAreaUseWoodPattern ?? defaults.courtPaintAreaUseWoodPattern,
    midRangeColor: colors.midRangeColor ?? defaults.courtMidRangeColor,
    midRangeUseWoodPattern:
      colors.midRangeUseWoodPattern ?? defaults.courtMidRangeUseWoodPattern,
    outOfBoundsColor: colors.outOfBoundsColor ?? defaults.courtOutOfBoundsColor,
    outOfBoundsUseWoodPattern:
      colors.outOfBoundsUseWoodPattern ?? defaults.courtOutOfBoundsUseWoodPattern,
    hideLogo: colors.hideLogo,
    hideBorders: colors.hideBorders,
  };

  if (courtType === "fullcourt") {
    return <BasketballFullCourt {...resolved} />;
  }

  return (
    <BasketballHalfCourt
      lineColor={resolved.lineColor}
      paintAreaColor={resolved.paintAreaColor}
      paintAreaUseWoodPattern={resolved.paintAreaUseWoodPattern}
      midRangeColor={resolved.midRangeColor}
      midRangeUseWoodPattern={resolved.midRangeUseWoodPattern}
      outOfBoundsColor={resolved.outOfBoundsColor}
      outOfBoundsUseWoodPattern={resolved.outOfBoundsUseWoodPattern}
      hideLogo={resolved.hideLogo}
      hideBorders={resolved.hideBorders}
    />
  );
}

